import { PayloadAction } from '@reduxjs/toolkit';
import {
	IIndustryPercentage,
	IIndustryPercentageSubQuestion,
} from '../../forms-v2/components/dynamic-fields/pi_industry_percentage/IIndustryPercentage';

export const IndustryPercentageReducer = {
	mergeListIndustries: (
		state: IIndustryPercentage,
		action: PayloadAction<IIndustryPercentageSubQuestion[]>
	) => {
		const clone = [];
		for (const item of action.payload) {
			clone.push(item);
		}
		state.list = clone;
		state.isStart = false;
	},
	resetListIndustries: (
		state: IIndustryPercentage,
		action: PayloadAction<any>
	) => {
		console.log('action', action);
		state.list = [];
		state.isStart = true;
	},
};
